import { render, staticRenderFns } from "./BookableCategoryEdit.vue?vue&type=template&id=1a17dba0&scoped=true"
import script from "./BookableCategoryEdit.vue?vue&type=script&lang=js"
export * from "./BookableCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a17dba0",
  null
  
)

export default component.exports